// removed by extract-text-webpack-plugin
module.exports = {"list":"_1vLFj _3kYJR","listItem":"_1ZXxG CO6xt","label":"_1-Vqi _3kYJR JmZU_ _3TD8R","emojiLabel":"CtDFn eTBAP","emojiIcon":"_2g6EI"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/Labels.css
// module id = 1624
// module chunks = 3